<script lang="ts">
	import { fade } from 'svelte/transition';

	interface Props {
		message?: string;
		duration?: number;
		class?: string;
	}

	let { message = $bindable(), duration = 3000, class: classList }: Props = $props();

	$effect(() => {
		if (message === undefined) return;
		const timeout = setTimeout(() => (message = undefined), duration);
		return () => clearTimeout(timeout);
	});
</script>

<!-- The live region stays in the DOM so screen readers announce messages added to it -->
<div role="status" aria-live="polite" class={classList}>
	{#if message !== undefined}
		<p m-0 p="x-4 y-2" rounded shadow-2xl bg-background-color transition:fade={{ duration: 125 }}>
			{message}
		</p>
	{/if}
</div>
